module.exports = {"341103003":"龙蟠街道","341103100":"乌衣镇","341103101":"沙河镇","341103102":"章广镇","341103103":"黄泥岗镇","341103104":"珠龙镇","341103105":"大柳镇","341103106":"腰铺镇","341103107":"施集镇","341103400":"南谯工业园区","341103401":"滁州高教科创城管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341103.json
// module id = 1111
// module chunks = 0